import {AbstractModule} from "../AbstractModule";
import {OvereasProcessor} from "../OvereasProcessor";

export class OrderPage extends AbstractModule {
    protected gatewayChanged: boolean = false;

    constructor(plugin: OvereasProcessor) {
        super(plugin);
        this.addGateChangeFormListeners();
    }

    // ################################################################
    // ###################### PRIVATE FUNCTIONS #######################

    protected addGateChangeFormListeners() {
        // only submit the gateway if the admin changed it
        this.plugin.$("#os-payment-gateway").on("change", (event) => {
            this.gatewayChanged = true;
        });
        this.plugin.$("form#post").on("submit", (event) => {
            if (this.gatewayChanged === true)
                return;
            this.plugin.$("#os-payment-gateway").attr("disabled", "disabled"); // disable it so it doesn't get submitted
        });
    }
}
